// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".diaBtns{width:80px;padding:10px}.glo_btnList_right{display:flex;align-items:center;margin-left:20px;max-width:180px;margin-bottom:10px}.glo_btnList_right .textBtn{font-size:13px;margin-left:12px;color:#2c6ae1;cursor:pointer}.glo_bgcMainColor{background-color:#ef7c0a!important;color:#fff!important;border:none!important}", ""]);
// Exports
module.exports = exports;
